import { render, staticRenderFns } from "./empty-state.vue?vue&type=template&id=6f874296"
import script from "./empty-state.vue?vue&type=script&lang=js"
export * from "./empty-state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f874296')) {
      api.createRecord('6f874296', component.options)
    } else {
      api.reload('6f874296', component.options)
    }
    module.hot.accept("./empty-state.vue?vue&type=template&id=6f874296", function () {
      api.rerender('6f874296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/empty-state.vue"
export default component.exports